import React, { useState } from 'react';
import styles from './ContentToggleSection.module.scss';

import { ReactComponent as VectorUp } from 'app/assets/Icons/VectorUp.svg';
import { IContentToggleSection } from './ContentToggleSection.interface';

export const ContentToggleSection = ({
  title,
  children,
  contentStyle,
  titleStyle
}: IContentToggleSection): React.JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = (): void => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div>
      <div
        className={styles.header}
        onClick={toggleCollapse}
        role="button"
        tabIndex={0}
        style={{ cursor: 'pointer' }}
      >
        <h1 style={titleStyle}>
          {title}
          <span style={{ marginLeft: '10px' }}>
            {isCollapsed ? (
              <VectorUp />
            ) : (
              <VectorUp
                style={{
                  transform: 'rotate(180deg)',
                  transition: 'transform 0.5s'
                }}
              />
            )}
          </span>
        </h1>
      </div>
      {!isCollapsed && <div style={contentStyle}>{children}</div>}
    </div>
  );
};

export default ContentToggleSection;
